<template>
	<!-- Shape of pages/events.vue: page header, grey "Featured" bar, then an event list. -->
	<div aria-hidden="true">
		<!-- `:search="true"` because pages/events.vue DOES pass `v-model` to
		     PageHeader, so the real header renders a search input. Omitting it
		     left the skeleton ~68px short and the page lurched down on mount. -->
		<PageHeaderSkeleton :search="true" />

		<!-- Featured event -->
		<div class="bg-gray-200 dark:bg-gray-800/50 md:py-14 flex justify-center p-8">
			<div class="w-full max-w-7xl flex flex-col md:items-center">
				<Skeleton class="h-4 w-24 mb-4 md:my-8 self-start" />
				<div class="w-full flex flex-col sm:flex-row gap-4 sm:gap-6">
					<Skeleton rounded="rounded-lg" class="w-full sm:w-1/3 aspect-video shrink-0" />
					<div class="w-full">
						<Skeleton class="h-6 md:h-8 w-3/4" />
						<Skeleton class="h-4 w-1/2 mt-3" />
						<Skeleton class="h-3 w-2/3 mt-4" />
					</div>
				</div>
			</div>
		</div>

		<!-- Event list -->
		<div class="w-full max-w-7xl mx-auto p-8 md:p-16 divide-y dark:divide-gray-800">
			<div v-for="n in 5" :key="n" class="flex gap-4 sm:gap-6 py-6 first:pt-0">
				<Skeleton rounded="rounded-lg" class="w-28 sm:w-40 aspect-video shrink-0" />
				<div class="w-full">
					<Skeleton class="h-5 w-2/3" />
					<Skeleton class="h-3 w-1/3 mt-3" />
					<Skeleton class="h-3 w-1/2 mt-2" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Skeleton from '../skeleton.vue'
import PageHeaderSkeleton from './page-header-skeleton.vue'

export default {
	name: 'EventsSkeleton',
	components: { Skeleton, PageHeaderSkeleton },
}
</script>
